import React, { Component } from 'react'
import { graphql, withApollo } from '@apollo/client/react/hoc'
import _, { flowRight as compose } from 'lodash'
import PropTypes from 'prop-types'

import TagsInput from '../../../components/ui/dataEntry/inputs/TagsInput'
import { utilityService } from '../../../services/UtilityService'
import LoadingButton from '../../../components/ui/general/buttons/LoadingButton'

import './../../../components/ui/ui.style.scss'

import QueryMatchStatusConfig from '../../../graphQL/admin/matchManager/getMatchStatusConfigList'
import MutationMatchStatusConfig from '../../../graphQL/admin/matchManager/updateMatchStatusModuleConfig'

const parentCompoent = 'match-status-management-container'

class MatchManagerStatusManagement extends Component {
  constructor (props) {
    super(props)
    this.state = {
      status: props.listMatchStatusConfig && props.listMatchStatusConfig.length ? props.listMatchStatusConfig : [],
      isUpdateDisabled: true,
      isLoading: false
    }
  }

  UNSAFE_componentWillReceiveProps = (newProps) => { // eslint-disable-line camelcase
    if (newProps && newProps.listMatchStatusConfig && !_.isEqual(this.props.listMatchStatusConfig, newProps.listMatchStatusConfig)) {
      this.setState({
        status: newProps.listMatchStatusConfig
      })
    }
  }

  handleStatusChange = (value, isDelete) => {
    const { status } = this.state
    let newStatus = [...status] || []
    if (isDelete) {
      const index = newStatus.indexOf(value)
      if (index > -1) {
        newStatus.splice(index, 1)
      }
    } else {
      if (!status) {
        newStatus = [value]
      } else {
        const index = newStatus.findIndex(item => item === value)
        if (index === -1) {
          newStatus.push(value)
        }
      }
    }
    const uniqueStatus = _.uniqBy(newStatus)
    this.setState({ status: uniqueStatus, isUpdateDisabled: false })
  }

  updateStatus = () => {
    const { onHistoryUpdate } = this.props
    this.setState({ isLoading: true })
    const { status } = this.state
    const newStatus = utilityService.getUniqueArr(status)
    const variables = {
      id: 'match_status',
      value: newStatus,
      module: 'Match',
      project: this.props.project
    }
    this.props.updateMatchStatus(variables).then(() => {
      if (onHistoryUpdate) {
        onHistoryUpdate()
      }
      this.setState({ isUpdateDisabled: true, status: newStatus, isLoading: false })
    }, errorMsg => {
      this.setState({ isLoading: false })
      utilityService.handleError(errorMsg)
    })
  }

  render () {
    const { status, isUpdateDisabled, isLoading } = this.state
    return (
      <div className='admin-portal match-manger-status-list' id='match-status-management-container'>
        <div className='input-field'>
          <label className='input-title'>Match Manager &gt; Status</label>
          <TagsInput
            selectedItems={status || []}
            tagList={[]}
            className={'match-management-status'}
            mode={'tags'}
            onChange={this.handleStatusChange}
            placeholder='Insert Tags'
            displayParameter='name'
            parentCompoent={parentCompoent}
          />
        </div>
        <div className='admin-footer' >
          <LoadingButton
            type='primary'
            onClick={this.updateStatus}
            htmlType='submit'
            buttonText={'Update'}
            buttonClass='save-btn'
            isLoading={isLoading}
            isDisabled={isUpdateDisabled}
          />
        </div>
      </div>
    )
  }
}

MatchManagerStatusManagement.propTypes = {
  /** project details */
  project: PropTypes.string
}

MatchManagerStatusManagement.defaultProps = {
}

export default withApollo(compose(
  graphql(
    QueryMatchStatusConfig,
    {
      options: (props) => {
        const { project } = props
        return {
          variables: { module: 'Match', project: project },
          fetchPolicy: 'network-only'
        }
      },
      props: (props) => {
        {
          const isListPresent = (props.data && props.data.listConfig && props.data.listConfig.length)
          const listValue = isListPresent ? props.data.listConfig.find(listItem => listItem.value) : null
          return {
            listMatchStatusConfig: listValue ? listValue.value : []
          }
        }
      }
    }
  ),
  graphql(
    MutationMatchStatusConfig,
    {
      props: (props) => ({
        updateMatchStatus: (variables) => {
          return props.mutate({
            variables
          })
        }
      })
    }
  )
)(withApollo(MatchManagerStatusManagement)))
